<template>
  <header-section
    title="Modelos de Evaluación"
    :tabs="tabs"
  >
    <router-view />
  </header-section>
</template>

<script>
import BaseSection from "@/components/global/layout/BaseSection.vue";

export default {
  name: "evaluation-criteria-tabs",
  extends: BaseSection,
  data: () => ({
    tabs: [
      {
        url: "/evaluation/localcriteria-config",
        title: "Criterios institucionales",
      },
      {
        url: "/evaluation/localcriteria-config/evaluationmodels",
        title: "Modelos de evaluación",
      },
    ],
  }),
};
</script>